import { memo } from 'react';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap_white.css';
import './tooltip.css';

export const CustomTooltip = memo(({ overLayText, icon }) => {

  return (
    <Tooltip
      placement='top'
      trigger={['hover']}
      overlay={
        <span>
          {overLayText}
        </span>
      }>
      <span>{icon}</span>
    </Tooltip>
  )
})